import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#114A4E",
      d: "M8.065 18v-1.523l4.04-3.96q.579-.585.966-1.04.386-.454.58-.88.192-.426.193-.91 0-.55-.25-.943a1.66 1.66 0 0 0-.688-.613 2.2 2.2 0 0 0-.994-.216q-.574 0-1.006.238a1.64 1.64 0 0 0-.67.665q-.233.431-.233 1.029H7.997q0-1.108.506-1.927a3.4 3.4 0 0 1 1.392-1.267q.892-.448 2.045-.448 1.17 0 2.057.437.887.438 1.375 1.199.495.76.495 1.739 0 .652-.25 1.284-.25.63-.881 1.397-.625.768-1.756 1.858l-2.006 2.04v.08h5.069V18z"
    }, null, -1)
  ])))
}
export default { render: render }